const jQ = jQuery.noConflict();

class setupGrayscaleClass{

	constructor(selector){
		this.sel = selector;
		this.itemImage = ".item-image img";
		this.itemPortrait = ".item-bottom-section__portrait img"
	}

	is_touch_device() {
	  return 'ontouchstart' in window || navigator.maxTouchPoints;
	}

	turnOffGrayFunc(e){	
		let hoverItem = jQ(e.currentTarget);
		let grayscaleItem = hoverItem.find(".grayscale");

		if(!this.is_touch_device()){
			if(!hoverItem.hasClass("open-item")){

				if(!jQ(grayscaleItem).hasClass('grayscale-off')){
					jQ(grayscaleItem).addClass('grayscale-off');
				}	

			}
		}
	
	}

	turnOnGrayFunc(e){
		
		let hoverItem = jQ(e.currentTarget);
		let grayscaleItem = hoverItem.find(".grayscale");

		if(!this.is_touch_device()){
			if(!hoverItem.hasClass("open-item")){
				if(jQ(grayscaleItem).hasClass('grayscale-off')){
					jQ(grayscaleItem).removeClass('grayscale-off');	
				}
				
			}
		}
	}


	init(){

		jQ(this.sel).on("mouseenter", (e) => {
			this.turnOffGrayFunc(e);
		});		

		jQ(this.sel).on("mouseleave", (e) => {
			this.turnOnGrayFunc(e);
		});	
			
	}
}

const setupGrayClass = new setupGrayscaleClass(".grid-item");

export default setupGrayClass;


// WEBPACK FOOTER //
// ./app/themes/nordic-concert-halls/js/utils/togglegrayscaleclass.js